<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import Currency from '../../components/Currency.vue'
import SportIcon from '@/components/SportIcon.vue'
import Loading from '@/components/Loading.vue'

const router = useRouter()

defineProps({
  recentActivity: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

// Methods
const navigateToEvent = (eventId) => {
  if (eventId) {
    router.push(`/event/${eventId}`)
  }
}
</script>

<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="info">mdi-clock-outline</v-icon>
      {{ $t('dashboard.recentActivity') }}
    </v-card-title>
    <v-card-text>
      <Loading v-if="loading" />
      <div v-else-if="recentActivity.length === 0" class="text-center py-8 text-medium-emphasis">
        {{ $t('dashboard.noRecentActivity') }}
      </div>
      <v-list v-else lines="two">
        <v-list-item
          v-for="activity in recentActivity"
          :key="activity.id"
          class="px-0"
          v-bind="activity.bet_type != 'combo' ? { onClick: () => navigateToEvent(activity.event.id) } : {}"
        >
          <template v-slot:prepend>
            <v-avatar 
              :color="activity.action === 'win' ? 'success' : (activity.action === 'lost' ? 'error' : 'blue-grey-darken-3')"
              size="32"
            >
              <v-icon size="20">
                {{ activity.action === 'win' ? 'mdi-trending-up' : (activity.action === 'lost' ? 'mdi-trending-down' : 'mdi-cards-playing') }}
              </v-icon>
            </v-avatar>
          </template>
          
          <v-list-item-title>
            <strong>{{ activity.player }}</strong> - {{ $t('action.' + activity.action) }}
          </v-list-item-title>
          
          <v-list-item-subtitle v-if="activity.bet_type == 'combo'">
            <v-icon>mdi-shape-outline</v-icon> 
            {{ $t('events.betting.betTypes.combo') }}
          </v-list-item-subtitle>

          <v-list-item-subtitle v-else-if="activity.event">
            <SportIcon :sportKey="activity.event.sport_key" class="me-1" size="16" />
            {{ activity.event.home_team }} vs {{ activity.event.away_team }}
          </v-list-item-subtitle>
          
          <template v-slot:append>
            <div class="text-right">
              <div 
                class="font-weight-bold"
                :class="{
                  'text-success': activity.action === 'win',
                  'text-error': activity.action === 'lost',
                }"
              >
                <Currency :amount="activity.amount" />
              </div>
              <div class="text-caption text-medium-emphasis">
                {{ $d(activity.time, 'long') }}
              </div>
              <v-icon 
                v-if="activity.event.id" 
                size="16" 
                class="ml-1 text-medium-emphasis"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </template>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-card {
  transition: transform 0.2s ease-in-out;
}

.v-card:hover {
  transform: translateY(-2px);
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.05);
}
</style>